export default "__VITE_ASSET__ba531e13__"